module.exports = __webpack_public_path__ + "img/cpu_syscall_impact.64ac15d0.png";